import { DESIGNATION_CONSTANTS_MAP } from "modules/Services";
import { getOrganizationId } from "modules/CommonSelectors";

export const MODE = {
  VIEW: "VIEW",
  EDIT: "EDIT",
};

export const PUBLISH_PERM_VALUES = {
  CREATE_AND_PUBLISH: "CREATE_AND_PUBLISH",
  CREATE_ONLY: "CREATE_ONLY",
};

export const MAP_LOCALES_TO_PERMS = {
  [PUBLISH_PERM_VALUES.CREATE_AND_PUBLISH]: "journal:create_and_publish",
  [PUBLISH_PERM_VALUES.CREATE_ONLY]: "journal:create_only",
};

export const ANNOUNCEMENT_ADMIN_ACCESS = "ADMIN_ACCESS";

export const ANNOUNCEMENT_STAFF_PERMS = {
  ANNOUNCEMENT_PUBLISH: {
    id: "125102698688157368",
    name: "StaffPermission:CircularPublishPermission",
  },
  ANNOUNCEMENT_MODULE: {
    id: "3356",
    name: "StaffPermission:Announcement",
  },
};

export const SORT_BY_ENTITY = {
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME",
  MIDDLE_NAME: "MIDDLE_NAME",
  FULL_NAME: "FULL_NAME",
  DISPLAY_ROLE: "DISPLAY_ROLE",
  PERMISSION: "PERMISSION",
};

export const SORT_BY_DIRECTION = {
  ASC: "ASC",
  DESC: "DESC",
};

export const USER_NAME_SORT_OPTIONS_V2 = [
  {
    key: "FIRSTNAME_AZ",
    label: "common:first_name_az",
    sortEntity: SORT_BY_ENTITY.FIRST_NAME,
    direction: SORT_BY_DIRECTION.ASC,
  },
  {
    key: "FIRSTNAME_ZA",
    label: "common:first_name_za",
    sortEntity: SORT_BY_ENTITY.FIRST_NAME,
    direction: SORT_BY_DIRECTION.DESC,
  },
  {
    key: "MIDDLENAME_AZ",
    label: "common:middle_name_az",
    sortEntity: SORT_BY_ENTITY.MIDDLE_NAME,
    direction: SORT_BY_DIRECTION.ASC,
  },
  {
    key: "MIDDLENAME_ZA",
    label: "common:middle_name_za",
    sortEntity: SORT_BY_ENTITY.MIDDLE_NAME,
    direction: SORT_BY_DIRECTION.DESC,
  },
  {
    key: "LASTNAME_AZ",
    label: "common:last_name_az",
    sortEntity: SORT_BY_ENTITY.LAST_NAME,
    direction: SORT_BY_DIRECTION.ASC,
  },
  {
    key: "LASTNAME_ZA",
    label: "common:last_name_za",
    sortEntity: SORT_BY_ENTITY.LAST_NAME,
    direction: SORT_BY_DIRECTION.DESC,
  },
  {
    key: "FULLNAME_AZ",
    label: "common:full_name_az",
    sortEntity: SORT_BY_ENTITY.FULL_NAME,
    direction: SORT_BY_DIRECTION.ASC,
  },
  {
    key: "FULLNAME_ZA",
    label: "common:full_name_za",
    sortEntity: SORT_BY_ENTITY.FULL_NAME,
    direction: SORT_BY_DIRECTION.DESC,
  },
];

export const DEFAULT_SETTINGS = {
  CIRCULAR_REVIEW_DEFAULT_SETTING: "CIRCULAR_REVIEW_DEFAULT_SETTING",
  CIRCULAR_DEFAULT_REVIEWERS: "CIRCULAR_DEFAULT_REVIEWERS",
};

export const getStaffPermsQueryVariables = ({
  curriculumProgramId,
  academicYearId,
}) => ({
  curriculumProgramId,
  organizationId: getOrganizationId(),
  circularReviewerFilters: { curriculumProgramId },
  configurationFilter: [
    ANNOUNCEMENT_STAFF_PERMS.ANNOUNCEMENT_PUBLISH.name,
    ANNOUNCEMENT_STAFF_PERMS.ANNOUNCEMENT_MODULE.name,
  ],
  filters: {
    designations: [DESIGNATION_CONSTANTS_MAP.TEACHER.id],
    curriculumProgramIds: [curriculumProgramId],
    academicYearIds: [academicYearId],
  },
  staffCoursesFilters: {
    curriculumProgramIds: [curriculumProgramId],
    academicYears: [academicYearId],
  },
});

export const getDefaultSettingsQueryVariables = curriculumProgramId => ({
  id: getOrganizationId(),
  input: {
    curriculumProgramId,
    settingsName: [
      DEFAULT_SETTINGS.CIRCULAR_REVIEW_DEFAULT_SETTING,
      DEFAULT_SETTINGS.CIRCULAR_DEFAULT_REVIEWERS,
    ],
  },
});
